import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FloApiResponse, Meta } from '../shared/models/api-response.model'
import { Observable } from 'rxjs'
import { IRankingDetail } from './interfaces/ranking-detail.interface'
import { IRanking } from './interfaces/ranking.interface'
import { FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'
import { EXPERIENCE_API_LEGACY_CORE_RANKINGS_PATH, EXPERIENCE_API_VERSION } from '../app.config'

@Injectable()
export class RankingsService {
  public ranking$: Observable<{ data: IRankingDetail; meta: Meta }>

  constructor(private http: HttpClient) {}

  public getRanking(id: number): Observable<{ data: IRankingDetail; meta: Meta }> {
    this.ranking$ = this.http.get<FloApiResponse<any>>(`${EXPERIENCE_API_LEGACY_CORE_RANKINGS_PATH}/${id}`, {
      params: {
        version: EXPERIENCE_API_VERSION
      }
    })
    return this.ranking$
  }

  public getRankings(limit: number) {
    return this.http.get<
      FloResponse<
        ReadonlyArray<IRanking>,
        {
          page: number
          limit: number
          total: number
        }
      >
    >(`${EXPERIENCE_API_LEGACY_CORE_RANKINGS_PATH}?sort=latestPublishDate`, {
      params: {
        limit: limit.toString(),
        version: EXPERIENCE_API_VERSION
      }
    })
  }
}
